const isBrowser = typeof window !== 'undefined';

export function safeStorageGet(storage, key) {
    if (!isBrowser || !storage) return null;
    try {
        return storage.getItem(key);
    } catch (e) {
        return null;
    }
}

export function safeStorageSet(storage, key, value) {
    if (!isBrowser || !storage) return false;
    try {
        storage.setItem(key, value);
        return true;
    } catch (e) {
        return false;
    }
}

